import { render, staticRenderFns } from "./TeachingRecords.vue?vue&type=template&id=2f6f2cf4&scoped=true"
import script from "./TeachingRecords.vue?vue&type=script&lang=js"
export * from "./TeachingRecords.vue?vue&type=script&lang=js"
import style0 from "./TeachingRecords.vue?vue&type=style&index=0&id=2f6f2cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f2cf4",
  null
  
)

export default component.exports